import angular from 'angular';


import templateUrl from './state-province-list.component.html';

export const StateProvinceListComponent = {
    controller: StateProvinceListController,
    controllerAs: "vm",
    templateUrl
};

function StateProvinceListController($q, stateProvinceService, utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = $onInit;
    vm.loaded = false;
    vm.saving = false;
    vm.stateProvinces;

    vm.anyDirty = anyDirty;
    vm.onSave = onSave;
    vm.onCancel = onCancel;

    function $onInit() {
        utilityService.showLoading();
        loadStateProvinces()
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }

    function onSave() {
        utilityService.showLoading();
        vm.saving = true;
        const saveAll = vm.stateProvinces.filter(function (stateProvince) {
            return stateProvince.dirty;
        }).map(function (stateProvince) {
            return stateProvinceService.patchStateProvince(stateProvince.StateProvinceID, stateProvince);
        });

        $q.all(saveAll)
            .then(function () {
                return loadStateProvinces();
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Saving failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.saving = false;
                utilityService.hideLoading();
            })
    }

    function onCancel() {
        vm.stateProvinces = angular.copy(vm.pristineStateProvinces);
    }

    function loadStateProvinces() {
        return stateProvinceService.retrieveStateProvinces()
            .then(function (stateProvinces) {
                vm.pristineStateProvinces = stateProvinces.sort(function (a, b) {
                    return a.StateName < b.StateName ? -1 : 1;
                });
                vm.stateProvinces = angular.copy(vm.pristineStateProvinces);
            });
    }

    function anyDirty() {
        return vm.stateProvinces.reduce(function (any, stateProvince) {
            return any || stateProvince.dirty;
        }, false);
    }
}
